<template>
  <div
    ref="rootRef"
    :class="[bem.b(), prepareClassNames()]"
    :style="{
      ...prepareStyles(),
    }"
  >
    <div ref="topRef">
      <EpForm v-bind="formProps" />
    </div>
    <div ref="middleRef" :class="bem.e('middle')">
      <div :class="bem.e('middle-left')">
        <EpButtons v-bind="buttonsProps" />
      </div>
      <div :class="bem.e('middle-right')">
        <EpButtons :list="searchButtons" />
      </div>
    </div>
    <slot name="tableBefore"></slot>
    <EpTable v-bind="tableProps" :before-search="beforeSearch" />
  </div>
</template>
<script setup lang="ts">
import { nextTick, ref } from 'vue'
import EpForm from '@el-plus/components/form'
import EpTable from '@el-plus/components/table'
import EpButtons from '@el-plus/components/buttons'
import { createNameSpace } from '@el-plus/utils/bem'
import {
  prepareProps,
  prepareEvents,
  prepareClassNames,
  prepareStyles,
} from '@el-plus/utils/props'
import { searchListPageProps, searchListPageEmits } from './search-list-page'
import { useSearchListPage } from './use-search-list-page'
defineOptions({ name: 'EpSearchListPage' })
const bem = createNameSpace('search-list-page')
const props = defineProps(searchListPageProps)
const emit = defineEmits(searchListPageEmits)

const {
  formProps,
  buttonsProps,
  searchButtons,
  search,
  reset,
  tableRef,
  formRef,
  tableProps,
  beforeSearch,
} = useSearchListPage(props, {}, emit)

defineExpose({
  search,
  reset,
  tableRef,
  formRef,
})
</script>
